export default __webpack_public_path__ + "d8235acda774690f14bd1edddf91bbfa.png";